<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full" id="portalView">
    <div class="vx-col mx-auto alignPortalCenter">
    <!-- <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mx-auto self-center"> -->
      <div class="vx-row mb-8">
        <div class="vx-col w-full text-center">
          <h1 style="letter-spacing: 5px;">
            <strong>Choose a Portal:</strong>
          </h1>
        </div>
      </div>
      <div class="vx-row portalView">
        <div class="vx-col pr-4 ">
          <div v-if="$acl.check('Teacher')">
            <div class="portal-img_container" @click="selectPortal(0)">
              <div class="vx-row mt-3">
                <div class="vx-col w-full text-center">
                  <img draggable="false" src="../assets/teacher-portal-logo.png" height="200px" />
                </div>
              </div>
              <div class="vx-row mt-3 mb-4">
                <div class="vx-col w-full">
                  <h3 class="text-center" style="letter-spacing: 2px;">
                    Teacher
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="portal-img_container" @click="selectPortal(1)">
              <div class="vx-row mt-3">
                <div class="vx-col w-full text-center">
                  <img draggable="false" src="../assets/student-portal-logo.png" height="200px" />
                </div>
              </div>
              <div class="vx-row mt-3 mb-4">
                <div class="vx-col w-full">
                  <h3 class="text-center" style="letter-spacing: 2px;">
                    Student
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-col pl-4">
          <div class="portal-img_container" @click="selectPortal(2)">
            <div class="vx-row mt-3">
              <div class="vx-col w-full text-center">
                <img draggable="false" src="../assets/admin-portal-logo.png" height="200px" />
              </div>
            </div>
            <div class="vx-row mt-3 mb-4">
              <div class="vx-col w-full">
                <h3 class="text-center" style="letter-spacing: 2px;">
                  Admin
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sites: [],
      selected: {}
    };
  },
  computed: {
    
  },
  mounted() {
    
  },
  created() {
    // document.title = "DigiCampus";
    this.$store.dispatch("updateTheme", "dark");
  },
  methods: {
    selectPortal(type) {
      if (type == 0) {
        let routeData = this.$router.resolve({ name: 'TeacherSubjects' });
        window.open(routeData.href, '_self');
      }
      else if (type == 1) {
        let routeData = this.$router.resolve({ name: 'BrowseContent' });
        window.open(routeData.href, '_self');
      }
      else if (type == 2) {
        let routeData = this.$router.resolve({ name: 'dashboard' });
        window.open(routeData.href, '_self');
      }
    }
  }
};
</script>
<style lang="scss">
#portalView{
  display: flex;
  align-self: center;
}
.portalView{
  display: flex;
  flex-wrap: unset;
  flex-direction: row;
}
.alignPortalCenter{
  align-self: center;
}
@media screen and (max-width: 500px){
  .portalView{
  display: flex;
  flex-wrap: unset;
  flex-direction: column;
  }
  .alignPortalCenter{
    align-self: unset;
  }
}
</style>